import React, { useEffect, useState } from "react";
import {
  getFormatDatesJst,
  getFormattedDateJst,
  getFormattedTimeJst,
} from "../../utils/dateformatter";

const Nav = () => {
  const [currentDate, setCurrentDate] = useState(getFormattedDateJst());
  const [currentTime, setCurrentTime] = useState(getFormattedTimeJst());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(getFormattedDateJst());
      setCurrentTime(getFormattedTimeJst());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  
  return (
    <>
      <div className="d-flex gap-5 mx-5 my-4 align-items-center">
        <div className="d-flex flex-column align-items-start gap-2 ">
          <img src="./logo_FD.png" alt="logo" className="logoLogin" />

          <img src="./Rectangle.png" alt="logo" />
        </div>

        <div className="d-flex flex-column align-items-start   ">
          <span className="fs-6">
            <img className="timeIcon" src="./Calendar.png" />
            <span className="dateFont"> {getFormatDatesJst(currentDate)}</span>
          </span>
          <span className="fs-6">
            <img className="timeIcon" src="./Clock.png" />
            <span className="dateFont">{currentTime}</span>
          </span>
        </div>
      </div>
    </>
  );
};

export default Nav;
